'use client';
import React, { useEffect, useState, useCallback } from 'react';
import { TeacherEventKeys, TeacherEvents } from '../events';
import { EventBus } from '@/shared/utils';
import { Teacher } from '@/shared/i18n';
import { Course, TeacherItem, TeacherList } from '../types';
import TeacherListComponent from '../ui/teacher-list-component';
import TeacherDetailComponent from '../ui/teacher-detail-component';
import { useRouter } from 'next/navigation';

type TeacherScreenProps = {
  eventBus: EventBus<TeacherEvents>;
  dict: Teacher;
  isSubscriber: boolean;
  initialData: { teacher: TeacherItem | TeacherList; topVideos?: Course[] } | null;
};

const TeacherScreen = ({ initialData, dict, eventBus, isSubscriber }: TeacherScreenProps) => {
  const [formType, setFormType] = useState<'list' | 'detail'>();

  // Callback per gestire l'evento "teachers/view"
  const handleViewList = useCallback(() => {
    console.log('Handling event: teachers/view');
    setFormType('list');
  }, []);

  // Callback per gestire l'evento "teacher/view"
  const handleViewDetail = useCallback(() => {
    console.log('Handling event: teacher/view');
    setFormType('detail');
  }, []);

  useEffect(() => {
    eventBus.on(TeacherEventKeys.teachers.view, handleViewList);
    eventBus.on(TeacherEventKeys.teacher.view, handleViewDetail);

    return () => {
      eventBus.off(TeacherEventKeys.teachers.view, handleViewList);
      eventBus.off(TeacherEventKeys.teacher.view, handleViewDetail);
    };
  }, [eventBus, handleViewList, handleViewDetail]);

  // Rendering in base al formType
  if (formType === 'list') {
    return (
      <TeacherListComponent
        eventBus={eventBus}
        teachers={initialData?.teacher as unknown as TeacherList}
        dict={dict}
      />
    );
  }
  if (formType === 'detail') {
    return (
      <TeacherDetailComponent
        eventBus={eventBus}
        teacher={initialData?.teacher as TeacherItem}
        mostViewedCourses={initialData?.topVideos}
        isSubscriber={isSubscriber}
        dict={dict}
      />
    );
  }

  return null; // Render fallback se `formType` non è ancora definito
};

export default TeacherScreen;
